import React, { useState, useEffect } from "react";
import ComapanyNameDetails from "../../../../components/common/forms/ComapanyNameDetails";
import DetailsOfShareHolders from "../../../../components/common/forms/DetailsOfShareHolders";
import FormBranch from "../../../../components/common/forms/FormBranch";
import FormButtom from "../../../../components/common/forms/FormButtom";
// import FormOtherDetails from "../../../../components/common/forms/FormOtherDetails";
// import FormUploadDocument from "../../../../components/common/forms/FormUploadDocument";
import MainObjectives from "../../../../components/common/forms/MainObjectives";
// import NotRegisteredCompany from "../../../../components/common/forms/NotRegisteredCompany";
// import OrderPage from "../../../../components/common/forms/OrderPage";
import { useForm } from "react-hook-form";
import Documents from "../../../../components/common/forms/Documents";
import { v4 as uuidv4 } from "uuid";
import FormPayment from "../../../../components/common/forms/FormPayment";

import {
  ward_registration,
  ward_upload_details,
  ward_shareholder,
  Ward_details_of_shareholder,
  ward_registration_v2,
} from "../WardRegistrationForm";
import api from "../../../../api/api";
import { toast } from "react-toastify";
import PrivateCompanyModal from "../../../../components/common/modal/CompanyFeeModal";
import WardRegistrationB from "../WardRgistrataionB/WardRgistrataionB";
import BackButton from "../../../../components/common/backbutton/BackButton";
import { useSelector } from "react-redux";
import AdminSearchCustomer from "../../common/AdminSearchCustomer";

const WardRegistrationA = () => {
  const { register, handleSubmit, unregister } = useForm();
  const [fieldChnage, setFieldChnage] = useState(true);
  const [shareHolders, setShareHolders] = useState([
    {
      ...ward_shareholder,
      id: uuidv4(),
    },
  ]);

  const [docsOutput, setDocsOutput] = useState([]);
  const [changeForm, setChangeForm] = useState(true);
  const [uploadProof, setUploadProof] = useState("");
  const { user, isSuccess } = useSelector((state) => state.auth);
  const [userID, setUserId] = useState(null);

  const [paymentRangeList, setPaymentList] = useState([]);
  const [amount, setAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [dueAmount, setDueAmount] = useState(null);
  const [paidAmount, setPaidAmount] = useState(null);

  // For amount calculation
  useEffect(() => {
    if (amount > 0) {
      let arr = paymentRangeList.filter((item) => {
        return (
          amount >= parseInt(item.range_start) &&
          amount <= parseInt(item.range_end)
        );
      });
      console.log(arr);

      arr.length > 0 && setTotalAmount(arr[0]?.amount);
    } else {
      setTotalAmount(0);
    }
  }, [amount, paymentRangeList]);

  // getting current user
  useEffect(() => {
    api
      .get("/users/me/")
      .then((response) => {
        setDueAmount(response.due_amount);
      })
      .catch((error) => {});
  }, []);

  // for filtering by company_type and show in Modal
  useEffect(() => {
    api
      .get(
        "/services/company/registration/service-charges/?company_type=ward_prop_part"
      )
      .then((response) => {
        // console.log(response.data)
        setPaymentList(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


  

  useEffect(() => {
    setAmount(0)
}, [fieldChnage])



// field change
  useEffect(() => {
    if (fieldChnage) {
      ward_registration_v2.map((item) => {
        unregister(item.name);
      });
    } else {
      ward_registration.map((item) => {
        unregister(item.name);
      });
    }
  }, [unregister, fieldChnage]);

  const handleClick = (data) => {
    data.share_holders = shareHolders;
    data.documents = docsOutput;

    if (user?.user_type === "CL") {
      const user = JSON.parse(localStorage.getItem("user"));
      data.user = user.user_id;
    } else {
      if (userID !== null) {
        data.user = userID;
      }
    }

    api
      .post("/services/company/", data)
      .then((response) => {
        toast.success("Data Registered Successfully.");

        let transactions = {
          // payment_mode: "e_wallet",
          amount: paidAmount,
          service_object_id: response.data.registration_id,
          created_by: response.data.registration_id,
          service_object_content_type: response.data.service_content_type_id,
          payment_proof: uploadProof,
          company: response.data.company_id,
          transaction_type: "credit",
        };

        api
          .post("/transactions/", transactions)
          .then((response) => {
            toast.success("Data Registered 2 Successfully.");
          })
          .catch((error) => {
            toast.error("Error in Transaction");
          });
      })
      .catch((error) => {
        toast.error("Data Registration Failed.");
      });
  };
  const ekal = () => {
    setFieldChnage(true);
  };
  const bahul = () => {
    setFieldChnage(false);
  };

  const formChangeA = () => {
    setChangeForm(true);
  };
  const formChangeB = () => {
    setChangeForm(false);
  };

  let data = [];
  // const initialState = {image:"", document_name:""}

  // creating initial state according to the length of documents
  ward_upload_details.map((item, i) => {
    data.push({ id: uuidv4(), image: "", document_name: "" });
    return "";
  });
  return (
    <div className=" lg:!px-14">
      <p className="text-primary-red font-Rakkas mt-7 text-center text-xl font-semibold tracking-wide underline md:!text-3xl">
        Ward Registration Form
      </p>

      <div className=" w-full flex flex-wrap gap-5 my-3 text-center justify-center">
        <div
          onClick={formChangeA}
          className={` ${
            changeForm === true
              ? "bg-primary-blue  text-white"
              : "bg-gray-300 text-primary-blue"
          } px-3  py-2 cursor-pointer  rounded-2xl font-bold`}
        >
          ब्यक्तिगत वा साझेदारी नयाँ ब्यवसाय वडामा दर्ता गर्नको लागि
        </div>
        <div
          onClick={formChangeB}
          className={` ${
            changeForm === false
              ? "bg-primary-blue  text-white"
              : "bg-gray-300 text-primary-blue"
          } px-3  py-2 cursor-pointer rounded-2xl font-bold`}
        >
          प्रा. लि. कम्पनीलाई वडामा दर्ता गर्नको लागि
        </div>
      </div>

      <div className="flex justify-between my-4">
        <p className="text-primary-blue font-Calistoga text-lg underline">
          1. Business Name & Other Details
        </p>
        <p className="text-primary-red flex">
          Firm No.
          <span className=" text-primary-blue"> 123</span>
        </p>
      </div>
      {/* business and company details */}

      {changeForm === true ? (
        <>
          {" "}
          <form className=" px-10">
            {(user?.user_type === "ST" || user?.user_type === "AD") && (
              <AdminSearchCustomer setUserId={setUserId} />
            )}

            <div className="border-primary-blue mt-3 border-2">
              <div className="flex md:flex-row items-center border-b border-primary-blue font-Laila flex-col ">
                <div className="border-primary-blue text-center text-primary-red  py-2  md:border-r md:w-[30rem]  text-lg font-bold">
                  कम्पनीको नाम
                </div>

                <div className="border-primary-blue flex md:flex-col-1 text-primary-red  border-r  py-2 w-full text-base font-bold sm:text-lg">
                  <p>नेपालीमा : </p>
                  <input
                    className="outline-none text-primary-blue pl-3 "
                    {...register(`company_name_nep`, {
                      // required: false,
                    })}
                  />
                </div>
                <div className="border-primary-blue flex text-primary-red   py-2 w-full text-base font-bold sm:text-lg">
                  <p>English मा : </p>
                  <input
                    className="outline-none text-primary-blue pl-3 "
                    {...register(`company_name`, {
                      // required: false,
                    })}
                  />
                </div>
              </div>
              <div className="flex border-b border-primary-blue w-full">
                <div className="border-primary-blue text-center text-primary-red border-r  py-2 md:w-[15rem]    text-lg font-bold">
                  कम्पनीको ठेगाना
                </div>
                <div className="border-primary-blue flex text-primary-red  w-full text-base font-bold sm:text-lg">
                  <input
                    className="outline-none text-primary-blue pl-3"
                    {...register(`company_address`, {
                      // required: false,
                    })}
                  />
                </div>
              </div>
              <div className="flex w-full">
                <div className="border-primary-blue text-primary-red  text-center border-r   py-2 md:w-[30.5rem] text-lg font-bold">
                  ब्यवसायको प्रकार
                </div>
                <div className="flex flex-wrap border-primary-blue gap-3 justify-center border-r items-center text-primary-red  w-full  text-base  sm:text-lg">
                  <div className="border-primary-blue border-r bg-primary-red flex items-center justify-center gap-1 rounded-full border px-3 py-0 text-white">
                    <label htmlFor="ekal">एकल </label>
                    <input
                      onClick={ekal}
                      type="radio"
                      name="radio-btn"
                      id="ekal"
                      value="ekal"
                      {...register("business_type", { required: false })}
                    />
                  </div>

                  <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full  px-3 py-0 text-white">
                    <label htmlFor="bahul">साझेदारी</label>
                    <input
                      onClick={bahul}
                      type="radio"
                      name="radio-btn"
                      value="bahul"
                      id="bahul"
                      {...register("business_type", { required: false })}
                    />
                  </div>
                  {/* <div className="rounded-xl bg-red-600 px-3 py-1 text-white">
                    test
                    </div> */}
                </div>
                <div className="flex flex-wrap border-primary-blue text-primary-red  gap-3 pl-5 w-full items-center text-base font-bold sm:text-lg">
                  ब्यवसायको प्रकृती:
                  <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border px-3 py-0 text-white">
                    <label htmlFor="trading"> ट्रेडिब </label>
                    <input
                      type="radio"
                      name="radio-btn"
                      value="trading"
                      className="bg-yellow"
                      // {...register("registration_nature", { required: false, })}
                      id="trading"
                    />
                  </div>
                  <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border px-3 py-0 text-white">
                    <label htmlFor="udhyog">औधोगिक</label>
                    <input
                      type="radio"
                      name="radio-btn"
                      value="industrial"
                      //  {...register("registration_nature", { required: false, })}
                      id="udhyog"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* business and company details close*/}

            <div className="w-full flex gap-1 md:flex-row flex-col items-center">
              {fieldChnage === true ? (
                <>
                  <div className="mt-4 border-2 border-primary-blue w-full">
                    {/* <div> */}
                    {ward_registration.map((item, i) => {
                      const { name, validation, ip1, type } = item;
                      return (
                        // <>
                        <div
                          key={i}
                          className=" border-primary-blue flex flex-col border-b md:flex-row  "
                        >
                          <div className="text-primary-red px-5 py-2 sm:!w-[350px] font-Laila font-bold">
                            {ip1}
                          </div>
                          <div className="md:border-l-2 border-t md:border-t-0 border-primary-blue text-primary-red  px-10 text-lg font-bold">
                            <input
                              type={type}
                              className=" w-full py-2 outline-none "
                              {...register(`${name}`, { required: false,
                              onChange: (e) => {e.target.name === "capital_to_invest" && setAmount(e.target.value)} 
                              
                              })}
                            />
                          </div>
                        </div>
                        // </>
                      );
                    })}

                    {/* </div> */}

                    <div className="bg-red-200 border-spacing-2 border-primary-blue  border-t- font-Laila text-primary-blue font-bold  py-5 text-center">
                      पुँजी र प्रकृतीको आधारमा तपाईको जम्मा लाग्ने रकम{" "}
                      <span className="text-red-600">रु.{totalAmount} </span> मात्र
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="mt-4 border-2 border-primary-blue w-full">
                    {/* <div> */}
                    {ward_registration_v2.map((item, i) => {
                      const { name, validation, ip1, type } = item;
                      return (
                        <div
                          key={i}
                          className=" border-primary-blue flex flex-col border-b md:flex-row  "
                        >
                          <div className="text-primary-red px-5 font-Laila py-2 sm:!w-[350px] font-bold">
                            {ip1}
                          </div>
                          <div className="md:border-l-2 borer-t border-primary-blue text-primary-red  px-10 text-lg font-bold">
                            <input
                              type={type}
                              className=" w-full py-2 outline-none "
                              {...register(`${name}`, { required: false,
                              onChange: (e) => {e.target.name === "capital_to_invest" && setAmount(e.target.value)}
                            
                            })}
                                
                            
                            />
                          </div>
                        </div>
                      );
                    })}

                    {/* </div> */}

                    <div className="bg-red-200 border-spacing-2 border-primary-blue font-Laila text-center  border-t-1 text-primary-blue font-bold  py-5 text-center">
                      साझेदारहरुको संख्या, ब्यवसायको प्रकृति र पुँजीको तपाईको
                      जम्मा लाग्ने रकम{" "}
                      <span className="text-red-600">रु.{totalAmount}।– </span> मात्र
                    </div>
                  </div>
                </>
              )}

              <div>
                <div>
                  <div className="border-primary-red text-primary-blue w-fit rounded-full border-2 p-2 text-base">
                    वडा कार्यालय मार्फत ब्यवसाय दर्ता गर्दा लाग्ने शुल्क
                    सम्बन्धि पूर्ण जानकारी लिनको लागि यहाँ{" "}
                    <span
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModalEdit"
                      className="text-primary-red cursor-pointer"
                    >
                      {" "}
                      Click
                    </span>{" "}
                    गर्नुहोस ।
                    <PrivateCompanyModal
                    paymentRangeList={paymentRangeList}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* ward registration v2 (bahul) */}
            {/* <div className="mt-4">
            <thead>
              <div>
                {ward_registration_v2.map((item, i) => {
                  const { name, validation, ip1, type } = item;
                  console.log(item);
                  return (
                    <div
                      key={i}
                      className="border-primary-blue flex flex-col md:flex-row"
                    >
                      <div className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
                        {ip1}
                      </div>
                      <div className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
                        <input type={type} />
                      </div>
                    </div>
                  );
                })}
              </div>
            </thead>
          </div> */}

            {/* details of share holders open */}
            <p className="text-primary-blue ont-Calistoga text-lg mt-5 underline">
              2. Details of Share Holders
            </p>

            <DetailsOfShareHolders
              DetailShareholder={Ward_details_of_shareholder}
              needed_share={ward_shareholder}
              setShareHolders={setShareHolders}
              shareHolders={shareHolders}
            />
            <div className="text-primary-blue text-lg font-Calistoga mt-6 mb-6 underline">
              3.Main Objective
              <span className="text-primary-blue font-Laila underline mx-2 ">
                ( यो व्यवसायले गर्ने मुख्य मुख्य कामहरु सहितको उद्देश्यहरु)
              </span>
            </div>
            <MainObjectives register={register} />
            {/* upload documents open */}
            {/* <div>
            <thead>
              <div>
                <div className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
                  S. N.
                </div>
                <div className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
                  Document Name
                </div>
                <div className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
                  Action
                </div>
                <div className="border-primary-blue text-primary-red border px-20 text-base font-bold sm:text-lg">
                  Remarks
                </div>
              </div>
            </thead>
            <tbody>
              {Gharelu_upload_details.map((item, index) => {
                return (
                  <div className="border-primary-blue border">
                    <div className="text-primary-red border-primary-blue border-r px-10 text-center font-semibold">
                      {item.sn}
                    </div>
                    <div className="p-0">
                      <p className="border-primary-blue text-primary-blue font-semibold m-0 h-[54px] w-full border-r py-3 px-3 outline-none">
                        {item.ip1}
                        <button className="bg-primary-blue text-white rounded-xl ml-3 px-2">
                          Upload
                        </button>
                      </p>
                    </div>
                    <div className="p-0">
                      <div className="border-primary-blue text-white m-0 h-[54px] w-full border-r py-3 px-3 outline-none space-x-2">
                        <button className="bg-primary-green rounded-xl px-2 ">
                          view
                        </button>
                        <button className="bg-primary-red rounded-xl px-2">
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </tbody>
          </div> */}
            <div className="text-primary-blue font-Calistoga text-lg mt-6 mb-6 underline">
              4. Upload Documents
              <span className="text-primary-blue underline font-Laila mx-2 ">
                (यो ब्यवसाय दर्ताको लागि आवश्यक पर्ने निम्न कागजपत्रहरु Upload
                गर्नुहोस् ।)
              </span>
            </div>

            <Documents
              documents_data={ward_upload_details}
              initialState={data}
              setDocument={setDocsOutput}
            />

            {/* upload documents close */}
            <div className="text-primary-blue text-lg my-3 font-Calistoga  underline">
              5. Working Branch{" "}
              <span className="text-primary-blue font-Laila">
                {" "}
                (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन
                शाखा नजिक पर्छ छनोट गर्नुहोस् ।)
              </span>
            </div>
            <FormBranch register={register} />
            <FormButtom />

            <FormPayment
              handleSubmit={handleSubmit}
              handleClick={handleClick}
              setUploadProof={setUploadProof}
              totalAmount={totalAmount}
              // setUploadProof={setUploadProof}
              dueAmount = {dueAmount}
              setPaidAmount = {setPaidAmount}

            />
          </form>
        </>
      ) : (
        <>
          <WardRegistrationB />
        </>
      )}
    </div>
  );
};

export default WardRegistrationA;
